import { useMemo } from 'react';
import { usePagination } from './usePagination';
export const usePaginationQueryVariables = () => {
    const { page, rowsPerPage } = usePagination();
    return useMemo(() => ({
        skip: page * rowsPerPage,
        first: rowsPerPage,
    }), [page, rowsPerPage]);
};
